module.exports = __webpack_public_path__ + "static/media/domeCover.01e180cf.png";